export default __webpack_public_path__ + "static/media/Group 391.19d7e11d.svg";